<div *ngIf="loading" class="h-full w-full flex align-items-center justify-content-center">
  <p-progressSpinner></p-progressSpinner>
</div>
